// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__e9c {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: fit-content;

  height: var(--badge-height);

  border: 1px solid;
  border-radius: var(--ring-border-radius);

  white-space: nowrap;
  font-size: var(--badge-font-size);
}

.wrapper__e9c.inline__ace {
  display: inline;
  line-height: calc(var(--badge-height) - 2px);
}

.wrapper__e9c.lg__f08 {
  /* 26px */
  --badge-height: calc(var(--ring-unit) * 3.25);
  --badge-font-size: var(--ring-font-size-smaller);

  border-radius: calc(var(--ring-border-radius) * 1.5);
  padding: 0 calc(var(--ring-unit) * 1.5 - 1px);
}

.wrapper__e9c.md__a1f {
  /* 22px */
  --badge-height: calc(var(--ring-unit) * 2.75);
  --badge-font-size: var(--ring-font-size-smaller);

  padding: 0 calc(var(--ring-unit) - 1px);
}

.wrapper__e9c.sm__bc7 {
  /* 16px */
  --badge-font-size: var(--ring-font-size-smaller);
  --badge-height: calc(var(--ring-unit) * 2);

  padding: 0 calc(var(--ring-unit) * 0.5 - 1px);
}

.wrapper__e9c.primary__a55 {
  --badge-main-color: var(--ring-main-color);
  --badge-fill-color: var(--ring-selected-background-color);
}

.wrapper__e9c.secondary__a3c {
  --badge-main-color: var(--ring-secondary-color);
  --badge-fill-color: var(--ring-border-disabled-color);
}

.wrapper__e9c.error__b63 {
  --badge-main-color: var(--ring-error-color);
  --badge-fill-color: var(--ring-removed-background-color);
}

.wrapper__e9c.warning__a99 {
  --badge-main-color: var(--ring-warning-color);
  --badge-fill-color: var(--ring-warning-background-color);
}

.wrapper__e9c.success__d89 {
  --badge-main-color: var(--ring-success-color);
  --badge-fill-color: var(--ring-added-background-color);
}

.wrapper__e9c.disabled__cf2 {
  --badge-main-color: var(--ring-text-color);
  --badge-fill-color: var(--ring-tag-background-color);
}

.wrapper__e9c.filled__ce7 {
  background: var(--badge-fill-color);
  border-color: var(--badge-fill-color);
  color: var(--badge-main-color);
}

.wrapper__e9c.outline__b6a {
  background: var(--badge-fill-color);
  border-color: var(--badge-main-color);
  color: var(--badge-main-color);
}

.wrapper__e9c.ghost__f80 {
  background: var(--ring-white-text-color);
  border-color: var(--badge-main-color);
  color: var(--badge-main-color);
}

.wrapper__e9c.fillContrast__bcf {
  color: var(--ring-white-text-color);
  background: var(--badge-main-color);
  border-color: var(--badge-main-color);
}
`, "",{"version":3,"sources":["webpack://./src/common/badge/general-badge/badge.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;;EAElB,2BAA2B;;EAE3B,iBAAiB;EACjB,wCAAwC;;EAExC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,6CAA6C;EAC7C,gDAAgD;;EAEhD,oDAAoD;EACpD,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,6CAA6C;EAC7C,gDAAgD;;EAEhD,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,0CAA0C;;EAE1C,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,yDAAyD;AAC3D;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,2CAA2C;EAC3C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;EAC7C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;EAC7C,sDAAsD;AACxD;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  width: fit-content;\n\n  height: var(--badge-height);\n\n  border: 1px solid;\n  border-radius: var(--ring-border-radius);\n\n  white-space: nowrap;\n  font-size: var(--badge-font-size);\n}\n\n.wrapper.inline {\n  display: inline;\n  line-height: calc(var(--badge-height) - 2px);\n}\n\n.wrapper.lg {\n  /* 26px */\n  --badge-height: calc(var(--ring-unit) * 3.25);\n  --badge-font-size: var(--ring-font-size-smaller);\n\n  border-radius: calc(var(--ring-border-radius) * 1.5);\n  padding: 0 calc(var(--ring-unit) * 1.5 - 1px);\n}\n\n.wrapper.md {\n  /* 22px */\n  --badge-height: calc(var(--ring-unit) * 2.75);\n  --badge-font-size: var(--ring-font-size-smaller);\n\n  padding: 0 calc(var(--ring-unit) - 1px);\n}\n\n.wrapper.sm {\n  /* 16px */\n  --badge-font-size: var(--ring-font-size-smaller);\n  --badge-height: calc(var(--ring-unit) * 2);\n\n  padding: 0 calc(var(--ring-unit) * 0.5 - 1px);\n}\n\n.wrapper.primary {\n  --badge-main-color: var(--ring-main-color);\n  --badge-fill-color: var(--ring-selected-background-color);\n}\n\n.wrapper.secondary {\n  --badge-main-color: var(--ring-secondary-color);\n  --badge-fill-color: var(--ring-border-disabled-color);\n}\n\n.wrapper.error {\n  --badge-main-color: var(--ring-error-color);\n  --badge-fill-color: var(--ring-removed-background-color);\n}\n\n.wrapper.warning {\n  --badge-main-color: var(--ring-warning-color);\n  --badge-fill-color: var(--ring-warning-background-color);\n}\n\n.wrapper.success {\n  --badge-main-color: var(--ring-success-color);\n  --badge-fill-color: var(--ring-added-background-color);\n}\n\n.wrapper.disabled {\n  --badge-main-color: var(--ring-text-color);\n  --badge-fill-color: var(--ring-tag-background-color);\n}\n\n.wrapper.filled {\n  background: var(--badge-fill-color);\n  border-color: var(--badge-fill-color);\n  color: var(--badge-main-color);\n}\n\n.wrapper.outline {\n  background: var(--badge-fill-color);\n  border-color: var(--badge-main-color);\n  color: var(--badge-main-color);\n}\n\n.wrapper.ghost {\n  background: var(--ring-white-text-color);\n  border-color: var(--badge-main-color);\n  color: var(--badge-main-color);\n}\n\n.wrapper.fillContrast {\n  color: var(--ring-white-text-color);\n  background: var(--badge-main-color);\n  border-color: var(--badge-main-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__e9c`,
	"inline": `inline__ace`,
	"lg": `lg__f08`,
	"md": `md__a1f`,
	"sm": `sm__bc7`,
	"primary": `primary__a55`,
	"secondary": `secondary__a3c`,
	"error": `error__b63`,
	"warning": `warning__a99`,
	"success": `success__d89`,
	"disabled": `disabled__cf2`,
	"filled": `filled__ce7`,
	"outline": `outline__b6a`,
	"ghost": `ghost__f80`,
	"fillContrast": `fillContrast__bcf`
};
export default ___CSS_LOADER_EXPORT___;
